import React, { useState, useEffect } from "react";
import { Box, Typography, CardMedia, Icon, Button, useMediaQuery, Dialog, DialogTitle, DialogContent, CircularProgress } from "@mui/material";
import BasicIcon from "../assets/PricePlanIcon/BasicIcon.png";
import PremiumIcon from "../assets/PricePlanIcon/PremiumIcon.png";
import { useWorkspace } from "../contexts/WorkspaceContext";
import { useNavigate } from "react-router-dom";
import { useCreditRecharge } from "../contexts/CreditRechageContext";
import { NavigationClick } from "../config/analytics";
import { handleAddCredit } from "../contexts/WorkspaceUtils";
import CommonToast from "../components/Common_Components/CommonToast";
import { useAuth } from "../contexts/AuthContext";
import PageLayout from "../components/navFoot/PageLayout";
import RequestDemoNearFooter from "../components/LandingPage/RequestDemoNearFooter";


const PricePage = ({callPlace}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState(null)
  const [iconType, setIconType] = useState(null)
  const [bgColor, setBgColor] = useState(null);
  const isBelow991 = useMediaQuery("(max-width:991px)");
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const [selectedPlanFilter, setSelectedPlanFilter] = useState("Personal Plan");
  // const {setShowSignUpModal} = useAuth()
  const {subscribe, subscribeType} = useWorkspace()

  const onClose = () =>{
    setOpen(false);
  }

  // console.log(subscribe, "subscribe")

  // useEffect(()=>{
  //   if(!isLoggedIn && !subscribe){
  //     setSelectedPlan("Monthly")
  //   }else if(isLoggedIn && subscribe){
  //     setSelectedPlan("Annual")
  //   }
  // },[isLoggedIn])

  const PlusPlanArray = [
    "Limited access to AI tools",
    "Advanced AI models",
    "20 Minutes Video Generation",
    "1000 Image Generation",
    "50 Minutes Audio Generation",
    "20 Presentation Generation",
    "Track up to 5 websites",
  ];
  
  const ProPlanArray = [
    "Limited access to AI tools",
    "Advanced AI models",
    "40 Minutes Video Generation",
    "2500 Image Generation",
    "100 Minutes Audio Generation",
    "40 Presentation Generation",
    "Track up to 10 websites",
  ];

    const ProMaxPlanArray = [
    "Unlimited access to AI tools",
    "Advanced AI models",
    "100 Minutes Video Generation",
    "Unlimited Image Generation",
    "Unlimited Audio Generation",
    "Unlimited Presentation Generation",
    "Track up to 15 websites",
    "Create & Host your website",
  ];

  const MonthlySMBmaxPlanArray = [
    "Unlimited access to AI tools",
    "Advanced AI models",
    "125 Minutes Video Generation & Personal Avatar Video",
    "Unlimited Image Generation",
    "Unlimited Audio Generation",
    "Unlimited Presentation Generation",
    "Track up to 15 websites",
    "Create & Host your website",
    "Hire AI calling agents for your business",
    "1000 Minutes of calling credit",
    "Access to a relationship manager",
  ];
  
  const MonthlySMBmaxManagedPlanArray = [
    "Unlimited access to AI tools",
    "Advanced AI models",
    "250 Minutes Video Generation & Personal Avatar Video",
    "Unlimited Image Generation",
    "Unlimited Audio Generation",
    "Unlimited Presentation Generation",
    "Track up to 15 websites",
    "Create & Host your website",
    "Hire AI calling agents for your business",
    "1000 Minutes of calling credit",
    "Access to a relationship manager",
    "Professional Social Media Management",
  ];

   const MonthlyCustomPlanArray = [
     "Customized As Per Your Need"
   ]

  //   const HandleMonthlyProPlanButtonClick =async (e) => {
  //   e.stopPropagation()
  //   if(isLoggedIn){
  //     const res = await handleAddCredit(setIsLoading, "1")
  //   }else{
  //     setContent("Please SignUp or Login ");
  //     setIconType('error')
  //     setBgColor("#282D51")
  //     setOpen(true)
  //     // setShowSignUpModal(true)
  //     navigate('./signup')
  //   }
  // };

  const handlePlanClick = async (e, planId) => {
    e.stopPropagation();
  
    if (isLoggedIn) {
      await handleAddCredit(setIsLoading, planId);
    } else {
      setContent("Please SignUp or Login");
      setIconType("error");
      setBgColor("#282D51");
      setOpen(true);
      // navigate("./signup");
    }
  };

  const HandleMonthlySMBMaxPlanButtonClick =async (e) => {
    e.stopPropagation()
    if(isLoggedIn){
      const res = await handleAddCredit(setIsLoading, "4")
    }else{
      setContent("Please SignUp or Login ");
      setIconType('error')
      setBgColor("#282D51")
      setOpen(true)
      // setShowSignUpModal(true)
      navigate('./signup')
    }
  };

    const HandleMonthlySMBMaxManagedButtonClick =async (e) => {
    e.stopPropagation()
    if(isLoggedIn){
      const res = await handleAddCredit(setIsLoading, "5")
    }else{
      setContent("Please SignUp or Login ");
      setIconType('error')
      setBgColor("#282D51")
      setOpen(true)
      // setShowSignUpModal(true)
      navigate('./signup')
    }
  };

  const handleBookCall = () => {
    window.open("https://calendly.com/makarand-modalx", "_blank");
  };

  const handleEmailClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    if(isBelow991){
      window.open("mailto:support@modalx.ai", "_blank");
    }else{
      window.open(`https://mail.google.com/mail/?view=cm&to=support@modalx.ai`, "_blank");
    }
  };

  return (
    <>
     <PageLayout>
      <Box>
        <Box
          sx={{
            display: callPlace === 'workspace' ? "none" : "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: isBelow991 ? "16px" : "28px",
            margin: isBelow991 ? "60px 0px" : "80px 0px",
          }}
        >
          <Box>
            {" "}
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize:  isBelow991 ? "28px" : "48px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "57.6px",
                letterSpacing: "-0.32px",
                color: "#FFFFFF",
                textAlign:"center"
              }}
            >
              Plans and Pricing
            </Typography>
          </Box>
          {/* <Box>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: isBelow991 ? "14px" :  "18px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "24px",
                letterSpacing: "0.1px",
                color: "rgba(255, 255, 255, 0.80)",
                textAlign:"center"
              }}
            >
              Choose the right plan for your business needs
            </Typography>
          </Box> */}
        </Box>






      <Box
            sx={{
              display: "flex",
              margin: "40px auto 40px auto",
              borderRadius: "100px",
              padding: "6px",
              border: "1px solid rgba(255, 255, 255, 0.20)",
              width: "300px",
              height: "48px",
              columnGap:"4px"
            }}
          >
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedPlanFilter("Personal Plan");
              }}
              sx={{
                width: "150px",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
                letterSpacing: "0.1px",
                color: "#ffffff",
                padding: "8px 12px",
                textTransform:"none",
                bgcolor:
                  selectedPlanFilter === "Personal Plan" ? "#1F233E" : "transparent",
                borderRadius: "100px",
                "&:hover": { bgcolor: "#282D51" },
                border:
                  selectedPlanFilter === "Personal Plan"
                    ? "1px solid rgba(255, 255, 255, 0.05)"
                    : "none",
              }}
            >
              Personal Plan
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedPlanFilter("Business Plan");
              }}
              sx={{
                width: "150px",
                display: "flex",
                padding: "8px 10px",
                borderRadius: "100px",
                textTransform:"none",
                bgcolor:
                  selectedPlanFilter === "Business Plan" ? "#1F233E" : "transparent",
                border:
                  selectedPlanFilter === "Business Plan"
                    ? "1px solid rgba(255, 255, 255, 0.05)"
                    : "none",
                "&:hover": {
                  bgcolor:
                    selectedPlanFilter === "Business Plan" ? "#1F233E" : "#282D51",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                  letterSpacing: "0.1px",
                  color: "#ffffff",
                  padding: "0px",
                }}
              >
                Business Plan
                {/* <Typography
                  component="span"
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    color: "#F6BE6B",
                    padding: "0px",
                    flexWrap: "nowrap",
                    marginLeft:"8px"
                  }}
                >
                  (Save 20%)
                </Typography> */}
              </Typography>
            </Button>
          </Box>
      </Box>

    {
      selectedPlanFilter === "Business Plan" ?    
      <Box
        sx={{
          display: "flex",
          flexDirection:  isBelow991 ? "column" : "row",
          columnGap: isBelow991 ? "0px" : "60px",
          rowGap: isBelow991 ? "40px" : "0px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
      {/* SMB Max Plan Card */}
      <Box  onClick={(e)=>{e.stopPropagation()}}
          sx={{
            width: "360px",
            height: "750px",
            border:"1px solid rgba(255, 255, 255, 0.10)",
            background: "#1F233E",
            borderRadius: "16px",
            padding: "30px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "12px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  SMB Max
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                Take your business growth to the next level with advanced AI tools
                </Typography>
              </Box>
                 <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  margin: "30px 0px",
                }}
              >
                <Typography
                                  sx={{
                                    fontFamily: "Inter",
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "24px",
                                    letterSpacing: "0.1px",
                                    color: "#FFFFFF",
                                    textDecoration: "line-through",
                                    marginRight:"12px"
                                  }}
                                >
                                  $999
                                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  $249
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  /month
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                }}
              >
                {MonthlySMBmaxPlanArray.map((ele, index) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        columnGap: "10px",
                      }}
                    >
                      <Box sx={{ height: "20px", width: "20px" }}>
                        <CardMedia
                          sx={{ height: "20px", width: "20px" }}
                          component="img"
                          image={BasicIcon}
                          alt="Loading"
                        />
                      </Box>
                      <Box sx={{ display: "flex", width: "370px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            letterSpacing: "0.1px",
                            color: "#FFFFFF",
                          }}
                        >
                          {ele}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box>
              <Button disabled={isLoggedIn && subscribe && ( subscribeType == "4" || subscribeType == "5" || subscribeType == "6")}
                onClick={(e)=>{handlePlanClick(e, "4")}}
                sx={{
                  width: "100%",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: (isLoggedIn && subscribe && (subscribeType == "4" || subscribeType == "5" || subscribeType == "6")) ? "rgba(40, 45, 81, 1)" : "#FFFFFF",
                  color: (isLoggedIn && subscribe && (subscribeType == "4" || subscribeType == "5" || subscribeType == "6")) ? "#CAC4D0" : "#17182C",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: (isLoggedIn && subscribe && (subscribeType == "4" || subscribeType == "5" || subscribeType == "6")) ? "rgba(40, 45, 81, 1)" : "#CDCFDF",
                  },
                  "&.Mui-disabled": {
                    color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                    bgcolor:(isLoggedIn && subscribe && (subscribeType == "4" || subscribeType == "5" || subscribeType == "6")) ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  },
              }}
              >
                {/* {isLoggedIn ? 
                subscribe && subscribeType == "1"  ? "Current plan" : callPlace==="workspace" ?  "Upgrade to Pro" : "Get started with Pro" 
                :
                "Get started with Pro"  } */}
                 {isLoggedIn ? 
                subscribe && subscribeType == "4"  ? "Current plan" : callPlace==="workspace" ?  "Upgrade to SMB Max" : "Get started with SMB Max" 
                :
                "Get started with SMB Max"  }
              </Button>
            </Box>
          </Box>
      </Box>

      {/* SMB Max Managed Plan Card */}
      <Box onClick={(e)=>{e.stopPropagation()}}
          sx={{
            width: "360px",
            height: "750px",
            border:  subscribeType === 5 || subscribeType === 4 || !subscribe  ? "1px solid #F6BE6B" : "1px solid rgba(255, 255, 255, 0.10)",
            background: "#1F233E",
            borderRadius: "16px",
            padding: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "12px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    columnGap: "12px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "20px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "20px",
                      letterSpacing: "0.1px",
                      color: "#FFFFFF",
                    }}
                  >
                    SMB Max Managed
                  </Typography>
                 {(subscribe && ( subscribeType === 5 || subscribeType === 6)) ? null : <Box
                    sx={{
                      bgcolor: "rgba(246, 190, 107, 0.20)",
                      border: "1px solid rgba(246, 190, 107, 1)",
                      borderRadius: "4px",
                      margin: "0px",
                      padding: "0px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "24px",
                        letterSpacing: "0.1px",
                        color: "#F6BE6B",
                        padding: "2px 4px",
                        margin: "0px",
                      }}
                    >
                      Popular
                    </Typography>
                  </Box>}
                </Box>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                   Business growth to unprecedented heights with the limitless potential of cutting-edge AI tools
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  margin: "30px 0px",
                }}
              >
                <Typography
                                  sx={{
                                    fontFamily: "Inter",
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "24px",
                                    letterSpacing: "0.1px",
                                    color: "#FFFFFF",
                                    textDecoration: "line-through",
                                    marginRight:"12px"
                                  }}
                                >
                                  $2499
                                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  $499
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  /month
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                }}
              >
                {MonthlySMBmaxManagedPlanArray.map((ele, index) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        columnGap: "10px",
                      }}
                    >
                      <Box sx={{ height: "20px", width: "20px" }}>
                        <CardMedia
                          sx={{ height: "20px", width: "20px" }}
                          component="img"
                          image={PremiumIcon}
                          alt="Loading"
                        />
                      </Box>
                      <Box sx={{ display: "flex", width: "370px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            letterSpacing: "0.1px",
                            color: "#FFFFFF",
                          }}
                        >
                          {ele}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box>
              <Button disabled={isLoggedIn && subscribe && ( subscribeType == "5" || subscribeType == "6")}
                onClick={(e)=>{handlePlanClick(e, "5")}}
                sx={{
                  width: "100%",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: "rgba(246, 190, 107, 1)",
                  color: "rgba(23, 24, 44, 1)",
                  borderRadius: "8px",
                  "&:hover": {
                        backgroundColor: "#ffd9aa", 
                  },
                  "&.Mui-disabled": {
                    color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                    bgcolor:(subscribe && subscribeType == 5) ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  },
                }}
              >
                {/* {isLoggedIn ? 
                subscribe && subscribeType == "4"  ? "Current plan" : callPlace==="workspace" ?  "Upgrade to SMB Max" : "Get started with SMB Max" 
                :
                "Get started with SMB Max"  } */}
                    {isLoggedIn ? (subscribe && subscribeType == 5 ? "Current plan" : (callPlace==="workspace" ?  (subscribe && (subscribeType == "1" || subscribeType == "2" || subscribeType == "3" )? "Get started with SMB Max Managed" : "Get started with SMB Max Managed" ): "Get started with SMB Max Managed")) : "Get started with SMB Max Managed"  }
              </Button>
            </Box>
          </Box>
      </Box>

      {/* Custom pricing Plan  Card */}
      <Box onClick={(e)=>{e.stopPropagation()}}
          sx={{
            width: "360px",
            height: "750px",
            border: ( subscribeType === 6 )? "1px solid #F6BE6B" : "1px solid rgba(255, 255, 255, 0.10)",
            background: "#1F233E",
            borderRadius: "16px",
            padding: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "12px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  Custom pricing
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  Tailored strategies and AI-powered solutions built around your unique business goals.
                </Typography>
              </Box>
               <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-end",
                                margin: "30px 0px",
                              }}
                            >
              
                            <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "24px",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "24px",
                                  letterSpacing: "0.1px",
                                  color: "#FFFFFF",
                                  // textDecoration: "line-through",
                                  marginRight:"12px"
                                }}
                              >
                                Contact for Estimate
                              </Typography>
                              {/* <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "24px",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "24px",
                                  letterSpacing: "0.1px",
                                  color: "#FFFFFF",
                                }}
                              >
                                $499
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "16px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "normal",
                                  letterSpacing: "0.1px",
                                  color: "rgba(255, 255, 255, 0.80)",
                                }}
                              >
                                /month
                              </Typography> */}
                            
                            </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                }}
              >
                {MonthlyCustomPlanArray.map((ele, index) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        columnGap: "10px",
                      }}
                    >
                      <Box sx={{ height: "20px", width: "20px" }}>
                        <CardMedia
                          sx={{ height: "20px", width: "20px" }}
                          component="img"
                          image={PremiumIcon}
                          alt="Loading"
                        />
                      </Box>
                      <Box sx={{ display: "flex", width: "370px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            letterSpacing: "0.1px",
                            color: "#FFFFFF",
                          }}
                        >
                          {ele}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box>
              <Button  disabled={(subscribeType == 6 )&& isLoggedIn}
                onClick={handleBookCall}
                sx={{
                  width: "100%",
                  height: "40px",
                  padding:"0px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  color: "rgba(246, 190, 106, 1)",
                  border:subscribe  && subscribeType == 6 ? "" : "1px solid rgba(246, 190, 106, 1)",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#282D51",
                  },
                  "&.Mui-disabled": {
                    color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                    bgcolor:subscribe && subscribeType == 6 ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  },
                }}
              >
                  {isLoggedIn ? (subscribe && subscribeType == 6 ? "Current plan" : (callPlace==="workspace" ?  (subscribe && (subscribeType == "1" || subscribeType == "2" || subscribeType == "3" || subscribeType == "4")? "Contact Us" : "Contact Us" ): "Contact Us")) : "Contact Us"  }
              </Button>
            </Box>
          </Box>
      </Box>
      </Box>
      : 
        <Box
        sx={{
          display: "flex",
          flexDirection:  isBelow991 ? "column" : "row",
          columnGap: isBelow991 ? "0px" : "60px",
          rowGap: isBelow991 ? "40px" : "0px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
      {/* Plus Plan Card */}
      <Box  onClick={(e)=>{e.stopPropagation()}}
          sx={{
            width: "360px",
            height: "600px",
            border: "1px solid rgba(255, 255, 255, 0.10)",
            background: "#1F233E",
            borderRadius: "16px",
            padding: "30px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "12px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  Plus
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                Take your business growth to the next level with advanced AI tools
                </Typography>
              </Box>
                 <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  margin: "30px 0px",
                }}
              >
                <Typography
                                  sx={{
                                    fontFamily: "Inter",
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "24px",
                                    letterSpacing: "0.1px",
                                    color: "#FFFFFF",
                                    textDecoration: "line-through",
                                    marginRight:"12px"
                                  }}
                                >
                                  $99
                                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  $49
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  /month
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                }}
              >
                {PlusPlanArray.map((ele, index) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        columnGap: "10px",
                      }}
                    >
                      <Box sx={{ height: "20px", width: "20px" }}>
                        <CardMedia
                          sx={{ height: "20px", width: "20px" }}
                          component="img"
                          image={BasicIcon}
                          alt="Loading"
                        />
                      </Box>
                      <Box sx={{ display: "flex", width: "370px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            letterSpacing: "0.1px",
                            color: "#FFFFFF",
                          }}
                        >
                          {ele}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box>
              <Button disabled={isLoggedIn && subscribe && (subscribeType == "1" || subscribeType == "2" || subscribeType == "3" || subscribeType == "4" || subscribeType == "5" || subscribeType == "6")}
                onClick={(e)=>{handlePlanClick(e, "2")}}
                sx={{
                  width: "100%",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: (isLoggedIn && subscribe && (subscribeType == "4" || subscribeType == "5" || subscribeType == "6")) ? "rgba(40, 45, 81, 1)" : "#FFFFFF",
                  color: (isLoggedIn && subscribe && (subscribeType == "4" || subscribeType == "5" || subscribeType == "6")) ? "#CAC4D0" : "#17182C",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: (isLoggedIn && subscribe && (subscribeType == "4" || subscribeType == "5" || subscribeType == "6")) ? "rgba(40, 45, 81, 1)" : "#CDCFDF",
                  },
                  "&.Mui-disabled": {
                    color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                    bgcolor:(isLoggedIn && subscribe && (subscribeType == "4" || subscribeType == "5" || subscribeType == "6")) ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  },
              }}
              >
                {/* {isLoggedIn ? 
                subscribe && subscribeType == "1"  ? "Current plan" : callPlace==="workspace" ?  "Upgrade to Pro" : "Get started with Pro" 
                :
                "Get started with Pro"  } */}
                 {/* {isLoggedIn ? 
                subscribe && subscribeType == "4"  ? "Current plan" : callPlace==="workspace" ?  "Upgrade to Plus" : "Get started with Plus" 
                :
                "Get started with Plus"  } */}
                Get started with Plus
              </Button>
            </Box>
          </Box>
      </Box>

      {/* Pro Plan Card */}
      <Box onClick={(e)=>{e.stopPropagation()}}
                      sx={{
                        width: "360px",
                        height: "600px",
                        border:  subscribeType === 5 || subscribeType === 4 || !subscribe  ? "1px solid #F6BE6B" : "1px solid rgba(255, 255, 255, 0.10)",
                        background: "#1F233E",
                        borderRadius: "16px",
                        padding: "25px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          height: "100%",
                        }}
                      >
                        <Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              rowGap: "12px",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                columnGap: "12px",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "20px",
                                  fontStyle: "normal",
                                  fontWeight: 700,
                                  lineHeight: "20px",
                                  letterSpacing: "0.1px",
                                  color: "#FFFFFF",
                                }}
                              >
                                Pro
                              </Typography>
                             {(subscribe && ( subscribeType === 5 || subscribeType === 6)) ? null : <Box
                                sx={{
                                  bgcolor: "rgba(246, 190, 107, 0.20)",
                                  border: "1px solid rgba(246, 190, 107, 1)",
                                  borderRadius: "4px",
                                  margin: "0px",
                                  padding: "0px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "24px",
                                    letterSpacing: "0.1px",
                                    color: "#F6BE6B",
                                    padding: "2px 4px",
                                    margin: "0px",
                                  }}
                                >
                                  Popular
                                </Typography>
                              </Box>}
                            </Box>
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "24px",
                                letterSpacing: "0.1px",
                                color: "rgba(255, 255, 255, 0.80)",
                              }}
                            >
                              Explore how the power of AI can help you with your business needs
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "flex-end",
                              margin: "30px 0px",
                            }}
                          >
                            <Typography
                                              sx={{
                                                fontFamily: "Inter",
                                                fontSize: "24px",
                                                fontStyle: "normal",
                                                fontWeight: 600,
                                                lineHeight: "24px",
                                                letterSpacing: "0.1px",
                                                color: "#FFFFFF",
                                                textDecoration: "line-through",
                                                marginRight:"12px"
                                              }}
                                            >
                                              $199
                                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: 600,
                                lineHeight: "24px",
                                letterSpacing: "0.1px",
                                color: "#FFFFFF",
                              }}
                            >
                              $99
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "normal",
                                letterSpacing: "0.1px",
                                color: "rgba(255, 255, 255, 0.80)",
                              }}
                            >
                              /month
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              rowGap: "16px",
                            }}
                          >
                            {ProPlanArray.map((ele, index) => {
                              return (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "flex-start",
                                    columnGap: "10px",
                                  }}
                                >
                                  <Box sx={{ height: "20px", width: "20px" }}>
                                    <CardMedia
                                      sx={{ height: "20px", width: "20px" }}
                                      component="img"
                                      image={PremiumIcon}
                                      alt="Loading"
                                    />
                                  </Box>
                                  <Box sx={{ display: "flex", width: "370px" }}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Inter",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "normal",
                                        letterSpacing: "0.1px",
                                        color: "#FFFFFF",
                                      }}
                                    >
                                      {ele}
                                    </Typography>
                                  </Box>
                                </Box>
                              );
                            })}
                          </Box>
                        </Box>
                        <Box>
                          <Button disabled={isLoggedIn && subscribe && (subscribeType == "1" || subscribeType == "3" || subscribeType == "4" || subscribeType == "5" || subscribeType == "6")}
                            onClick={(e)=>{handlePlanClick(e, "1")}}
                            sx={{
                              width: "100%",
                              height: "40px",
                              textTransform: "none",
                              fontFamily: "Inter",
                              fontSize: "16px",
                              fontWeight: 600,
                              textAlign: "center",
                              bgcolor: "rgba(246, 190, 107, 1)",
                              color: "rgba(23, 24, 44, 1)",
                              borderRadius: "8px",
                              "&:hover": {
                                    backgroundColor: "#ffd9aa", 
                              },
                              "&.Mui-disabled": {
                                color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                                bgcolor:(subscribe && subscribeType == 5) ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                              },
                            }}
                          >
                                {isLoggedIn ? (subscribe && subscribeType == 5 ? "Current plan" : (callPlace==="workspace" ?  (subscribe && (subscribeType == "1" || subscribeType == "2" || subscribeType == "3" )? "Get started with Pro" : "Get started with Pro" ): "Get started with Pro")) : "Get started with Pro"  }
                          </Button>
                        </Box>
                      </Box>
                  </Box>

      {/* Pro max Plan  Card */}
      <Box onClick={(e)=>{e.stopPropagation()}}
          sx={{
            width: "360px",
            height: "600px",
            border: ( subscribeType === 6 )? "1px solid #F6BE6B" : "1px solid rgba(255, 255, 255, 0.10)",
            background: "#1F233E",
            borderRadius: "16px",
            padding: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "12px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "#FFFFFF",
                  }}
                >
                  Pro Max
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "0.1px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  Tailored strategies and AI-powered solutions built around your unique business goals.
                </Typography>
              </Box>
               <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-end",
                                margin: "30px 0px",
                              }}
                            >
              
                            <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "24px",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "24px",
                                  letterSpacing: "0.1px",
                                  color: "#FFFFFF",
                                  textDecoration: "line-through",
                                  marginRight:"12px"
                                }}
                              >
                                $499
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "24px",
                                  fontStyle: "normal",
                                  fontWeight: 600,
                                  lineHeight: "24px",
                                  letterSpacing: "0.1px",
                                  color: "#FFFFFF",
                                }}
                              >
                                $199
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "Inter",
                                  fontSize: "16px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "normal",
                                  letterSpacing: "0.1px",
                                  color: "rgba(255, 255, 255, 0.80)",
                                }}
                              >
                                /month
                              </Typography>
                            </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                }}
              >
                {ProMaxPlanArray.map((ele, index) => {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        columnGap: "10px",
                      }}
                    >
                      <Box sx={{ height: "20px", width: "20px" }}>
                        <CardMedia
                          sx={{ height: "20px", width: "20px" }}
                          component="img"
                          image={PremiumIcon}
                          alt="Loading"
                        />
                      </Box>
                      <Box sx={{ display: "flex", width: "370px" }}>
                        <Typography
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            letterSpacing: "0.1px",
                            color: "#FFFFFF",
                          }}
                        >
                          {ele}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box>
              <Button   disabled={(subscribeType == 6 || subscribeType == 5 || subscribeType == 4 || subscribeType == 3 )&& isLoggedIn}
                onClick={(e)=>{handlePlanClick(e, "3")}}
                sx={{
                  width: "100%",
                  height: "40px",
                  padding:"0px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  color: "rgba(246, 190, 106, 1)",
                  border:subscribe  && subscribeType == 6 ? "" : "1px solid rgba(246, 190, 106, 1)",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#282D51",
                  },
                  "&.Mui-disabled": {
                    color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                    bgcolor:subscribe && subscribeType == 6 ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  },
                }}
              >
              {/* {isLoggedIn ? (subscribe && subscribeType == 6 ? "Current plan" : (callPlace==="workspace" ?  (subscribe && (subscribeType == "1" || subscribeType == "2" || subscribeType == "3" )? "Get started with SMB Max Managed" : "Get started with SMB Max Managed" ): "Get started with SMB Max Managed")) : "Get started with SMB Max Managed"  } */}
              Get started with Pro Max
              </Button>
            </Box>
          </Box>
      </Box>
      </Box>
    }

      <Box  sx={{ display: callPlace === 'workspace' ? "none" : "flex", justifyContent: "center", margin: isBelow991 ? "60px 0px" : "80px 0px" }}>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "24px",
            letterSpacing: "0.1px",
            color: "#FFFFFF",
            textAlign:"center",
          }}
        >
          Have questions? {<br/>} 
          <span onClick={handleBookCall} style={{ textDecorationLine: "underline", cursor:"pointer" }}>Book a call with us</span>{isBelow991 && <br/>} 
          <span style={{margin:"0px 8px", opacity:0.8}}>{`OR`}</span>{isBelow991 && <br/>} 
          Contact us at <span onClick={handleEmailClick} style={{ textDecorationLine: "underline", cursor:"pointer", color: "#ffffff" }}>support@modalx.ai</span>
         
          
        </Typography>
      </Box>
      <Box
          sx={{
            marginTop: "100px",
            display: (callPlace== "workspace" || callPlace== "landing") ? "block" : "none"
          }}
        >
          <RequestDemoNearFooter />
        </Box> 
      </PageLayout> 
      {/* for payment success */}

      <Dialog
        open={isLoading}
        disableBackdropClick
        disableEscapeKeyDown
        PaperProps={{ style: { padding: '20px', textAlign: 'center' } }}
      >
        <DialogTitle>{"Processing..."}</DialogTitle>
        <DialogContent>
          <CircularProgress />
          <Typography variant="h6" style={{ marginTop: '15px' }}>
            Wait!.. Do not refresh the screen.
          </Typography>
        </DialogContent>
      </Dialog>    

      {/* Comman Alert  */}
        {/* <PricePage /> */}
      <CommonToast open={open} onClose={onClose} content={content} iconType={iconType} bgColor={bgColor}/>
    </>
  );
};

export default PricePage;
